import { z } from 'zod';

export const ParkAllocateResponseSchema = z.object({
  roomId: z.string().min(1),
});
export type ParkAllocateResponse = z.infer<typeof ParkAllocateResponseSchema>;

export const HealthResponseSchema = z.object({
  ok: z.literal(true),
  uptime: z.number().nonnegative(),
  rooms: z.number().int().nonnegative(),
  players: z.number().int().nonnegative(),
});
export type HealthResponse = z.infer<typeof HealthResponseSchema>;
